import React, { useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useFormData } from "../../context";
import NameInfo from "../inputs/NameInfo";
import NavigationStep from './NavigationStep';
import { storePurpose, providePurpose } from "../../utils/Purpose";
import { checkForm } from "../../utils/Api";
import { areFieldsEqual } from '../../utils/ObjectCompare';
import { env } from '../../env'

export default function NameInfoStep(props) {
    // Declare state variables using useForm
    const { purposeId, route, nextRoute, prevRoute,  provider } = props
    const navigate = useNavigate();
    const { pathname, search } = useLocation();

    const { setFormValues, data } = useFormData();
    const { handleSubmit, formState, control, reset, watch } = useForm({ mode: "onSubmit", defaultValues: { user: providePurpose('df.us', purposeId) } });
    const { errors } = formState;
    let isCheckingSubmit = false;

    // Declare effects using useEffect
    useEffect(() => {
        if (data.user) {
            reset({ user : data.user });
        }
    }, [data.user, reset]);


    useEffect(() => {
        document.title = 'CPA - Details';
    }, []);

    // Declare event handlers or other functions
    const onSubmit = (args) => {
        if (env.VITE_ENV && env.VITE_ENV.toLowerCase() !== 'production') {
            console.log(`NameInfoStep.onSubmit`);
            console.log(args);
        }

        if (args.user.title !== 'Other' && (args.user.otherTitle || args.user.otherTitle === null)) {
            delete args.user.otherTitle;
        }

        setFormValues(args);

        if (!data.user || !areFieldsEqual(data.user, args.user, ['title', 'otherTitle', 'firstName','lastName','emailAddress'])) {
            setFormValues({ userChange: true });
        }

        //let user = { user: args.user };
        storePurpose('df.us', args.user, purposeId);
        handleFormCheck(args.user.emailAddress);
    };

    const handleFormCheck = async (emailAddress) => {
        if (env.VITE_ENV && env.VITE_ENV.toLowerCase() !== 'production') {
            console.log(`FormSubmitted.handleFormSubmit`);
        }

        if (!isCheckingSubmit) {
            isCheckingSubmit = true;
            var checkResponse = await checkForm(provider, emailAddress);
            isCheckingSubmit = false;
            if (checkResponse.status === 409) {
                navigate({ pathname: "/alreadysubmitted", replace: false, preserveSearch: true, search });
            } else {
                navigate({ pathname: nextRoute, replace: false, preserveSearch: true, search });
            }
        }
    };

    // Render JSX using state variables and other variables
    return (
        <div className="container" style={pathname === route ? {} : { display: 'none' }}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <NameInfo control={control} errors={errors} watch={watch} />
                <NavigationStep prevRoute={prevRoute} />
            </form>
        </div>
    );
};